/**
 * Created by Denis Kuzin on 25 february 2022
 */

const Clans = function () {
    this.top = [];
    this.list = [];

    this.onClansListRefreshed = function () {};
};

Clans.prototype.updateTop = function (onSuccess, onFailure) {
    if (cleverapps.flags.nomulti) {
        onSuccess();
        return;
    }

    cleverapps.RestClient.get(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/listtop`, {}, (data) => {
        this.top = data.map((info) => new Clan(info));

        onSuccess();
    }, onFailure);
};

Clans.prototype.listTop = function () {
    let founded = false;

    for (let index = 0; index < this.top.length; index++) {
        if (this.top[index].isUserClan()) {
            this.top[index] = cleverapps.userClan;
            founded = true;
        }
    }

    if (!founded && cleverapps.userClan.id !== undefined) {
        this.top.push(cleverapps.userClan);
    }

    this.top = this.top.sort((a, b) => b.rating - a.rating);

    return this.top;
};

Clans.prototype.updateList = function (name, onSuccess, onFailure) {
    if (cleverapps.flags.nomulti) {
        onSuccess();
        return;
    }
    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/list`, { name }, (data) => {
        this.list = data.map((info) => new Clan(info));
        onSuccess();
        this.onClansListRefreshed();
    }, onFailure);
};

Clans.prototype.listClans = function () {
    return this.list;
};

Clans.prototype.search = function (name, onSuccess) {
    cleverapps.loading.show();

    const waiter = cleverapps.wait(2, () => {
        cleverapps.loading.hide();
        onSuccess && onSuccess();
    });

    setTimeout(waiter, 1000);

    this.updateList(name, waiter, waiter);
};

Clans.prototype.create = function (options) {
    let action = "create";
    let price = ClansConfig.CREATION_PRICE;

    if (options.clanId) {
        action = "edit";
        price = ClansConfig.EDITING_PRICE;
    }

    if (!cleverapps.user.canTakeHard(price)) {
        cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.CLAN, price);
        return;
    }

    cleverapps.loading.show();

    const onFailure = function (error) {
        cleverapps.loading.hide();
        cleverapps.focusManager.display({
            focus: "NoConnectionWindow",
            stack: true,
            action: function (f) {
                new NoConnectionWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
        console.log(error);
    };

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/${action}`, {
        userId: connector.platform.getUserID(),
        name: options.name,
        emblem: options.emblem,
        rating: GameLevelHelper.GetMainInstance().getLevel(),
        requiredLevel: options.requiredLevel,
        userName: connector.player.name,
        userAvatar: connector.player.avatar
    }, (data) => {
        if (data.error) {
            if (data.error.code === "ER_DUP_ENTRY") {
                cleverapps.notification.create(Messages.get("ClanErrors.duplicateNames"));
                cleverapps.loading.hide();
                return;
            }
            onFailure(data.error);
            return;
        }

        cleverapps.loading.hide();

        cleverapps.userClan.update(data);

        cleverapps.focusManager.closeAllWindows();

        cleverapps.focusManager.display({
            focus: "MyClanWindow",
            stack: true,
            action: function (f) {
                new MyClanWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });

        cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.CLAN, price);
    }, onFailure);
};

Clans.prototype.addUserToClan = function (userId, clanId, onSuccess, onError) {
    cleverapps.loading.show();

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/join`, {
        userId,
        clanId,
        userRating: GameLevelHelper.GetMainInstance().getLevel(),
        userName: connector.player.name,
        userAvatar: connector.player.avatar
    }, onSuccess, onError);
};

Clans.prototype.join = function (clanId) {
    this.addUserToClan(connector.platform.getUserID(), clanId, (data) => {
        cleverapps.loading.hide();

        if (data.error) {
            cleverapps.notification.create(Messages.get(data.error));
        } else {
            cleverapps.userClan.update(data);

            cleverapps.focusManager.closeAllWindows();

            cleverapps.focusManager.display({
                focus: "MyClanWindow",
                stack: true,
                action: function (f) {
                    new MyClanWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    }, (err) => {
        cleverapps.loading.hide();
        cleverapps.focusManager.display({
            focus: "NoConnectionWindow",
            stack: true,
            action: function (f) {
                new NoConnectionWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
        console.log(err);
    });
};

Clans.prototype.leave = function () {
    cleverapps.loading.show();

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/leave`, {
        userId: connector.platform.getUserID(),
        clanId: cleverapps.userClan.id
    }, () => {
        cleverapps.loading.hide();

        cleverapps.userClan.update({});

        cleverapps.focusManager.closeAllWindows();
    }, (err) => {
        cleverapps.loading.hide();
        cleverapps.focusManager.display({
            focus: "NoConnectionWindow",
            stack: true,
            action: function (f) {
                new NoConnectionWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
        console.log(err);
    });
};

Clans.prototype.autofit = function () {
    cleverapps.loading.show();

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/autofit`, {
        userRating: GameLevelHelper.GetMainInstance().getLevel()
    }, (data) => {
        cleverapps.loading.hide();

        if (data.error) {
            cleverapps.notification.create(Messages.get(data.error));
        } else {
            this.join(data.clanId);
        }
    }, () => {
        cleverapps.loading.hide();
    });
};

Clans.prototype.getUserRole = function () {
    cleverapps.RestClient.get(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/userclan/${encodeURIComponent(connector.platform.getUserID())}`, {
        userId: connector.platform.getUserID()
    }, (data) => data);
};

Clans.IsAvailable = function () {
    if (cleverapps.gameModes.clans) {
        return true;
    }

    const isCheater = cleverapps.user.currentPhysicalLevel.level >= 100 && !cleverapps.isLocalhost();
    return !isCheater && cleverapps.userClan && cleverapps.userClan.id !== undefined && levels.user.checkAvailable(cleverapps.config.availables.CLANS);
};
